import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/registrationDeliveryHistorical/${dossierId}`, method: 'GET', token: token })
}
